export default {
  // 表格列標題
  currency: "幣種",
  keyActions: "關鍵行為",
  counterparty: "交易對手",
  transactionAmount: "交易數量",
  transactionTime: "交易時間",

  // 加載和狀態
  loading: "拼命加載中",
  noData: "暫無數據",
  tooMuchData: "當前地址交易數據過多，暫時不支持此類數據的查看",

  // 消息提示
  copySuccess: "複製成功",
};
